import { useSelector } from 'react-redux';

export const useModuleHasPermissions = (moduleName) => {
   const loadModules = useSelector((state) => state.authState.user?.roleDetails?.modules);
   let permissions = {
      canRead: false,
      canAdd: false,
      canUpdate: false,
      canDelete: false,
   };
   if (!loadModules) return permissions;

   const getModule = loadModules?.find((module) => module.name === moduleName);
   if (!getModule) return permissions;

   const hasPermissions = (getModule ?? []).permission ?? [];
   if (!hasPermissions) return permissions;

   hasPermissions?.forEach((perm) => {
      if (perm.name === 'add') permissions.canAdd = true;
      if (perm.name === 'read') permissions.canRead = true;
      if (perm.name === 'update') permissions.canUpdate = true;
      if (perm.name === 'delete') permissions.canDelete = true;
   });

   return permissions;
};
